import { AuditItem } from "./base/AuditNamedItem";
import { Stage } from "./stage";

export class Deal extends AuditItem {
  dealID: number = 0;
  contactPersonID!: number;
  assigntoId!: number;
  organizationID!: number;
  title!: string;
  value: string = "100";
  pipelineID!: number;
  stageID!: number;
  labelID!: number;
  probability: string = "100";
  expectedCloseDate: string | null = null;
  clinicID!: number;
  sourceID!: number;
  treatmentID!: number;
  enquiryID!: number;
  paName: string = null as any;
  operationDate: string | null = null;
  lostReviewReason: string = "test";
  pipelineTypeID!: number;
  visibilityGroupID!: number;
  phone: string = "test";
  email: string = "test";
  personName!: string;
  name: string = "test";
  pipelineName!: string;
  stageName!: string;
  labelName!: string;
  clinicName!: string;
  sourceName!: string;
  treatmentName!: string;
  enquiryDetails!: string;
  pipelineTypeName!: string;
  visibilityGroupName!: string;
  status?: string; // Add this if it's not already there
  isClosed!: boolean; // Add this if it's not already there
  openDealsCount?: number;
  statusID?:number;
  ownerName!: string;
  comments?: string | null;
  reason?: string | null; 
  callHistory: CallHistoryEntry[] = []; 
  wonTime!:string;
  marketing_GCLID?: string | null;
  marketing_source?: string | null;
  marketing_medium?: string | null;
  marketing_term?: string | null;
  marketing_content?: string | null;
  submission_id?: string | null;
  MarketingConsent?: string | null;
  TCCONSENT?: string | null;
  Marketing_FBClid?: string | null;
  MarketingCreatedDate?: string | null;
  newContact?: {
    personName: string; // This is required
    email?: string; // Required
    phone?: string; // Required
    reason?: string;
    comments?: string;
  };
  // constructor(dealID: number = null as any,
  //     contactPersonID: number = null as any,
  //     organizationID: number = null as any,
  //     title: string = null as any,
  //     value: string = null as any,
  //     pipelineID: number = null as any,
  //     stageID: number = null as any,
  //     labelID: number = null as any,
  //     probability: string = null as any,
  //     expectedCloseDate: string = null as any,
  //     clinicID: number = null as any,
  //     sourceID: number = null as any,
  //     treatmentID: number = null as any,
  //     enquiryID: number = null as any,
  //     paName: string = null as any,
  //     operationDate: string = null as any,
  //     lostReviewReason: string = null as any,
  //     pipelineTypeID: number = null as any,
  //     visibilityGroupID: number = null as any,
  //     phone: string = null as any,
  //     email: string = null as any,
  //     personName: string = null as any,
  //     name: string = null as any,
  //     pipelineName: string = null as any,
  //     stageName: string = null as any,
  //     labelName: string = null as any,
  //     clinicName: string = null as any,
  //     sourceName: string = null as any,
  //     treatmentName: string = null as any,
  //     enquiryDetails: string = null as any,
  //     pipelineTypeName: string = null as any,
  //     visibilityGroupName: string = null as any) {
  //     this.dealID = dealID;
  //     this.contactPersonID = contactPersonID;
  //     this.organizationID = organizationID;
  //     this.title = title;
  //     this.value = value;
  //     this.pipelineID = pipelineID;
  //     this.stageID = stageID;
  //     this.labelID = labelID;
  //     this.probability = probability;
  //     this.expectedCloseDate = expectedCloseDate;
  //     this.clinicID = clinicID;
  //     this.sourceID = sourceID;
  //     this.treatmentID = treatmentID;
  //     this.enquiryID = enquiryID;
  //     this.paName = paName;
  //     this.operationDate = operationDate;
  //     this.lostReviewReason = lostReviewReason;
  //     this.pipelineTypeID = pipelineTypeID;
  //     this.visibilityGroupID = visibilityGroupID;
  //     this.phone = phone;
  //     this.email = email;
  //     this.personName = personName;
  //     this.name = name;
  //     this.pipelineName = pipelineName;
  //     this.stageName = stageName;
  //     this.labelName = labelName;
  //     this.clinicName = clinicName;
  //     this.sourceName = sourceName;
  //     this.treatmentName = treatmentName;
  //     this.enquiryDetails = enquiryDetails;
  //     this.pipelineTypeName = pipelineTypeName;
  //     this.visibilityGroupName = visibilityGroupName;

  // }
  MissedCallReason: string = "Not Provided";
  RecordingUrl: string = "";
  Status: string = "Pending";
  medicalForm: string | undefined;
  address!: string;
  birthday!: string;
  occupation!: string;
  customFields!: any[];
 pipelineStages: Stage[] = [];
  lostReason: any;


}
// Define the CallHistoryEntry type to avoid any issues with missing fields
export type CallHistoryEntry = {
  assignedTo: string;
  receivedOn: string;
  campaign: {
    id: number;
    name: string;
    type: string; // Added this to match API expectations
  };
  contactName: string;
  contactEmail: string;
  contactNumber: string;
  id: number;
  justCallNumber: string;
  agentName: string;
  callDate: string;
  callTime: string;
  type: string;
  recording: string;
  callInfo: {
    direction: string;
    disposition: string;
    notes: string;
    recording: string; // Ensure recording exists
    type: string; // Ensure type exists
  };
};

export class DealMove {
  newStageId!: number;
  modifiedById!: number;
  dealId!: number;
  pipelineId!: number;
}

export class DealCustomFields extends AuditItem {
  id!: number;
  dealFieldId!: number;
  fieldName!: string;
  fieldType!: string;
  fieldValue!: string;
  pipelineId!: any;
  pipelineIds!: any;
  dealId!: number;
  options!: any;
}

export interface DealTimeLine {
  dealId: number;
  eventType: string;
  eventDescription: string;
  eventDate: string;
  timeline:string;
  activityDetail: string;
  callDateTime: string;
  contactNumber: string;
  duration: number;
  eventTypeId:number;
}

export enum EntitType {
  Deal = 1,
  Note = 2,
  Email = 3,
  Task = 4,
  Comment = 8
}

export class DealExport {
  minAmount!: any
  assignedToId!: any
  pipelineIDs!: string
  startDate!: any
  endDate!: any
  stageId!: any
}

